// extracted by mini-css-extract-plugin
export default {"Status":"Status_Status__NiKI-","circle":"Status_circle__yf-wv"};